const clearCartStyles = {
    container: `flex flex-col gap-[15px] sm:gap-[20px] items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white text-black p-[18px]
                min-w-[300px] max-w-[400px] 
                sm:p-[25px] sm:min-w-[unset]
    `,
    closeIcon: `absolute top-1 right-4`,
    heading: `text-[20px] font-[600] leading-[13px] py-[8px]
              sm:text-[24px]
    `,
    description: `flex items-center max-w-[80%]`,
    confirmationText: `text-[14px] text-center
                      sm:text-[16px]
    `,
    buttonContainer: `flex flex-row justify-between w-full gap-2`,
    button: `min-w-[48%] !bg-white !text-themeColor !border-gray-300 hover:!bg-gray-100`,
    cancelButton: `min-w-[48%] !bg-primaryHeading`,
}

export { clearCartStyles }